import { render, staticRenderFns } from "./XVideos.vue?vue&type=template&id=06b365b7&scoped=true"
import script from "./XVideos.vue?vue&type=script&lang=js"
export * from "./XVideos.vue?vue&type=script&lang=js"
import style0 from "./XVideos.vue?vue&type=style&index=0&id=06b365b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b365b7",
  null
  
)

export default component.exports